import { render, staticRenderFns } from "./home-quiz-card.vue?vue&type=template&id=1427ab97&"
import script from "./home-quiz-card.vue?vue&type=script&lang=ts&"
export * from "./home-quiz-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports